import { SailingPerformance } from '@didi/sailing-data-tools';
import router from '@/router';

export function setPerformanceTiming(config) {
  try {
    const { name = '' } = config;
    const now = Date.now();
    new SailingPerformance({
      env: process.env.NODE_ENV,
      Omega: window.Omega,
      router: router,
      prefix: name,
      initTime: now,
    });
  } catch (err) {
    console.log('性能指标收集包报错'.concat(err));
  }
}
